module.exports = __webpack_public_path__ + "media/backgrounds/dennis-mita-6pOB4LkAFs0-unsplash-93565652.jpg";